import React from 'react'
import {
  CardWrap,
  CardMainWrap,
  Avatar,
  CardHeadingWrap,
  CardSubHeading,
  Tag,
  CardHeading,
  CardSubHeadingAdditional,
  Button,
} from '@reapit/elements'

interface Listing {
  thumbnail?: string;
  tag?: string;
  categoryLabel?: string;
  label: string;
  crm_key?: string;
}

type Props = {
  setShowLocationPicker?: (show: boolean) => void;
  listing: Listing;
  userAccountType?: string;
  className?: string;
}

const LocationCard: React.FC<Props> = ({ listing, className, setShowLocationPicker, userAccountType }) => {
  type Intent = 'default' | 'warning' | 'primary' | 'pending' | 'neutral' | 'success'
  const getIntent = (t?: string): Intent => {
    switch ((t ?? '').toLowerCase()) {
      case 'applicant':
        return 'warning'
      case 'property':
        return 'primary'
      case 'valuation':
        return 'neutral'
      case 'tenancy':
        return 'pending'
      case 'offer':
        return 'success'
      case 'sale':
        return 'success'
      case 'people':
      default:
        return 'default'
    }
  }

  function showDanger(listing: Pick<Listing, 'categoryLabel'>, userAccountType: string | undefined) {
    if (
      listing.categoryLabel !== userAccountType &&
      listing.categoryLabel !== 'Both' &&
      userAccountType &&
      userAccountType !== 'Both'
    ) {
      return true
    }
    return false
  }
  
  return (
    <>
      <div className={showDanger(listing, userAccountType) ? 'invalid-category' : ''}>
        <CardWrap className={className}>
          <CardMainWrap>
            {listing.thumbnail ? (
              <Avatar type="image" src={listing.thumbnail} />
            ) : (
              <div role="img" title="An avatar image" className="el-avatar-image el-avatar">
                <img src={`./blank-${listing.tag}.png`} className="avatar" />
              </div>
            )}
            {setShowLocationPicker ? (
              <p className="clicktochange" onClick={() => setShowLocationPicker(true)}>
                <Button>Click to Change</Button>
              </p>
            ) : null}
            <span className="warning-text">Warning - This is a {listing.categoryLabel} card</span>
            <CardHeadingWrap>
              <CardSubHeading>
                <span style={{ display: 'block', marginBottom: '5px' }}>
                  <Tag intent={getIntent(listing.tag)}>{listing.tag ?? 'Contact'} Record</Tag>{' '}
                  {listing.categoryLabel ? (
                    <Tag intent={showDanger(listing, userAccountType) ? 'danger' : getIntent(listing.tag)}>
                      {listing.categoryLabel}
                    </Tag>
                  ) : null}
                </span>
              </CardSubHeading>
              <CardHeading style={{ marginTop: '5px', fontWeight: '600' }}>{listing.label}</CardHeading>
              <CardSubHeadingAdditional style={{ fontSize: '15px', marginTop: '2px' }}>
                {listing.crm_key}
              </CardSubHeadingAdditional>
            </CardHeadingWrap>
          </CardMainWrap>
        </CardWrap>
      </div>
    </>
  )
}

export default LocationCard
